export const aiDescriptionBlockSubId = "aiDescriptionBlockSubId";
